import {html, LitElement} from 'lit';
import {customElement, property, query} from 'lit/decorators.js';
import {chNavItemStyles} from "@/components/ch-nav-item/ch-nav-item.style";


@customElement('sbk-ch-nav-item')
export class SbkChNavItem extends LitElement {
    @property({ type: Boolean, reflect: true }) active = false;

    @query('sbk-link') _link!: HTMLLinkElement;
    @query('img') _img!: HTMLImageElement;

    @property()
    href? = '';

    @property()
    icon? = '';

    private _onMouseOver!: EventListenerOrEventListenerObject;
    private _onMouseOut!: EventListenerOrEventListenerObject;

    static get styles() {
        return chNavItemStyles;
    }

    firstUpdated() {
        if (!this._link || !this._img) return;

        this._onMouseOver = () => {
            this._img.classList.add('hovered');
        };

        this._onMouseOut = () => {
            this._img.classList.remove('hovered');
        };

        this._link.addEventListener('mouseover', this._onMouseOver);
        this._link.addEventListener('mouseout', this._onMouseOut);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        if (this._link) {
            this._link.removeEventListener('mouseover', this._onMouseOver);
            this._link.removeEventListener('mouseout', this._onMouseOut);
        }
    }

    render() {
        return html`
            <div class=${this.active ? 'nav-item--active' : ''}>
                <img src=${this.icon} width="40px" height="40px" />
                <sbk-link is-bold variant="regular" href=${this.href} size="md">
                    <slot></slot>
                </sbk-link>
            </div>
        `;
    }
}
